
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

const getDoctorLogin = async () => {

  const query = `
    query MyQuery {
      userlogeado {
        id
        username
        detalleusuario {
          persona {
            id
            primerApellido
            primerNombre
            doctorSet {
              id
              especialidad {
                codEsp
                descripcion
              }
            }
          }
        }
      }
    }
  `;

  try{
    const user = JSON.parse(localStorage.getItem('usuario'));
    axios.defaults.headers.common.Authorization = `JWT ${user.token}`

    const response = await axios.post(rutas.axios + 'api', { query });

    const data = response.data.data.userlogeado.detalleusuario;
    return data;
  }catch(error){
    console.log(error);
    return null;
  }
}




export const authService = {
  getDoctorLogin
}